<script lang="ts">
  import type { Snippet } from "svelte";
  import CtaPair from "#lib/site/CtaPair.svelte";
  import { ENTRANCE_FRAME, PRODUCT_HERO } from "#lib/ui/recipes.ts";

  let {
    headline,
    lede,
    testId,
    picture,
  }: {
    headline: string;
    lede: string;
    testId: string;
    picture: Snippet;
  } = $props();
</script>

<section class={[ENTRANCE_FRAME, "pt-14 pb-12 md:pt-20"]} data-testid={testId}>
  <div class="mx-auto flex max-w-3xl flex-col items-center gap-6 text-center">
    <h1 class={[PRODUCT_HERO, "text-ink-1"]}>{headline}</h1>
    <p class="max-w-2xl text-bar leading-7 text-ink-2">{lede}</p>
    <CtaPair {testId} />
  </div>
  <div class="mt-14 md:mt-16">{@render picture()}</div>
</section>
